export default __webpack_public_path__ + "media/images/features/ana/irakakairou-20a13a42a3df3079178b929ab5bf6e3d.jpg";